import ApiService from "./ApiService";
import utilityService from "./utilityService";

const getAll = async () => {
  const url = "/GetAllBURunChargeType";
  try {
    const result = await ApiService.get(url);

    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const getOne = async (id) => {
  const url = `/GetBURunChargeType?Id=${id}`;
  try {
    const result = await ApiService.get(url);
    if (result.data) return result.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  const url = "/UpdateBURunChargeType?" + utilityService.queryString(data);

  try {
    const result = await ApiService.post(url);
    debugger;
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to update BU Run Charge",
    };
  }
};

const add = async (data) => {
  const url = "/AddBURunChargeType?" + utilityService.queryString(data);
  debugger;
  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to add new BU Run Charge",
    };
  }
};

const remove = async (id) => {
  const url = "/DeleteBURunChargeType?Id=" + id;

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
    return {
      success: false,
      message: "Failed to remove BU Run Charge",
    };
  }
};

export default {
  getAll,
  getOne,
  update,
  add,
  remove,
};
